import { Button, Icon } from '@pms-digital/design-system';

export interface FilteredEmptyStateProps {
  onReset: () => void;
  /**
   * In a folder, or in « Hors dossier »: searches the same filters across
   * every matrix (« Toutes les matrices »). Left out in « Toutes les matrices ».
   */
  onSearchEverywhere?: () => void;
}

/**
 * What the grid shows after its « + » card when the filters leave nothing
 * (issue #19: the card stays first and visible, it no longer disappears).
 */
export function FilteredEmptyState({ onReset, onSearchEverywhere }: FilteredEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border-2 border-gray-200 border-dashed px-6 py-12 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-gray-100 text-gray-500">
        <Icon name="search_off" size={16} />
      </span>
      <h2 className="mt-1 font-semibold text-body-lg">
        Aucune matrice ne correspond à ces filtres
      </h2>
      <p className="mb-2 text-gray-600 text-small">
        Modifiez ou retirez un filtre pour retrouver vos matrices.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button type="button" variant="primary" size="sm" onClick={onReset}>
          Réinitialiser les filtres
        </Button>
        {onSearchEverywhere && (
          <Button type="button" variant="ghost" size="sm" onClick={onSearchEverywhere}>
            Chercher dans toutes les matrices
          </Button>
        )}
      </div>
    </div>
  );
}
